<div id="lightbox"
     class="lightbox clearfix">
  <!-- 
    Usamos [@cartState]="isOpen ? 'open' : 'closed'" en 
    el elemento que se anima (white_content, en tu caso).
  -->
  <div class="white_content"
       [@cartState]="isOpen ? 'open' : 'closed'">

    <!-- Botón para cerrar (antes id="close") -->
    <a href="#"
       class="textright"
       (click)="closeCart()">
      <i class="fa-regular fa-circle-xmark"></i>
    </a>

    <div class="cart-popup">
      <ul>
        <li class="d-flex align-items-center position-relative">
          <div class="p-img light-bg">
            <img src="assets/images/p-1.png"
                 alt="Product Image">
          </div>
          <div class="p-data">
            <h3 class="font-semi-bold">Fosroc Galvafroid – 400ml</h3>
            <p class="theme-clr font-semi-bold">1 x $18.60</p>
          </div>
          <!-- Ejemplo: eliminar item #1 -->
          <a href="#"
             (click)="removeItem(1)"
             id="crosss"></a>
        </li>

        <li class="d-flex align-items-center position-relative">
          <div class="p-img light-bg">
            <img src="assets/images/p-1.png"
                 alt="Product Image">
          </div>
          <div class="p-data">
            <h3 class="font-semi-bold">Fosroc Galvafroid – 400ml</h3>
            <p class="theme-clr font-semi-bold">1 x $18.60</p>
          </div>
          <a href="#"
             (click)="removeItem(2)"
             id="cross"></a>
        </li>
      </ul>

      <div class="cart-btn">
        <div class="cart-total d-flex align-items-center justify-content-between">
          <span class="font-semi-bold">Total:</span>
          <span class="font-semi-bold">$40.20</span>
        </div>

        <div class="cart-btns d-flex align-items-center justify-content-between">
          <a class="font-bold"
             href="#"
             (click)="viewCart()">
            View Cart
          </a>
          <a class="font-bold theme-bg-clr text-white checkout"
             href="#"
             (click)="checkout()">
            Checkout
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
